import { render, staticRenderFns } from "./vistaOficios.vue?vue&type=template&id=2d4b947c"
import script from "./vistaOficios.vue?vue&type=script&lang=js"
export * from "./vistaOficios.vue?vue&type=script&lang=js"
import style0 from "./vistaOficios.vue?vue&type=style&index=0&id=2d4b947c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports